import { useEffect, useState } from "react";
import { loadClevertap } from "../components/configuration/dynamic-scripts";
import { useSelector } from "react-redux";

const useCleverTap = () => {
    const { user } = useSelector(store => store);
    const {isLoggedIn } = user || {};
    const [isCleverTapLoaded, setIsCleverTapLoaded] = useState(false);

    useEffect(() => {
        const loadAndSetStatus = () => {
            if (!window?.clevertap && isLoggedIn) {
                loadClevertap(() => setIsCleverTapLoaded(true)); return;
            }
            setIsCleverTapLoaded(false);
        };

        loadAndSetStatus();
    }, [isLoggedIn]);

    return isCleverTapLoaded;
};

export default useCleverTap;
